const ROUTES = {
  PRODUCT: '/product',
  PRODUCTS: '/products',
  CATEGORIES: '/categories',
  ATTRIBUTES: '/attributes',
  ATTRIBUTE_VALUES: '/attribute-values',
};

export default ROUTES;
